import { LegalDonateLinkCard } from "@/components/ui/admin/legal/LegalDonateLinkCard";
import { LegalPanel } from "@/components/ui/admin/legal/LegalPanel";
import { useTranslations } from "@/lib/useTranslations";

export function LegalPage() {
  const t = useTranslations("legal");

  return (
    <div className="mx-auto flex w-full max-w-6xl flex-1 flex-col gap-6 overflow-y-auto px-6 py-10">
      <header className="space-y-1">
        <p className="text-sm font-medium uppercase tracking-widest text-neutral-500">
          {t("eyebrow")}
        </p>
        <h1 className="text-3xl font-semibold tracking-tight text-whart-text">
          {t("title")}
        </h1>
        <p className="text-sm text-neutral-600">{t("subtitle")}</p>
      </header>

      <LegalDonateLinkCard />
      <LegalPanel />
    </div>
  );
}
